export default __webpack_public_path__ + "static/1177-1d30b30cdaff66e6b1f8fcba64dbc570.gif";